import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { legacyKYCStatus, legacyKYCStatusText } from "./styles_vanilla.css";

const LegacyKycStatus: React.FC = () => {
  return (
    <Flex className={legacyKYCStatus} flexDirection="row" alignItems="center" gap={8}>
      <Icon type="flag-checkered" data-testid="legacy-kyc-icon" />
      <Text variant="strong-md">Closed</Text>
      <Text className={legacyKYCStatusText} variant="secondary-md">
        Legacy KYC IDS
      </Text>
    </Flex>
  );
};

export default LegacyKycStatus;
